document.addEventListener('click', async (event) => {
  const cta = event.target.closest('.product__ritual-steps-modal-cta');

  if (!cta) return;

  event.preventDefault();

  if (cta.getAttribute('aria-disabled') === 'true') return;

  const form = document.getElementById(cta.dataset.productFormId);

  if (!form) {
    window.location.href = cta.href;
    return;
  }

  cta.setAttribute('aria-disabled', 'true');
  cta.classList.add('loading');

  try {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = new FormData(form);

    const response = await fetch(routes.cart_add_url, config);
    const result = await response.json();

    if (!response.ok || result.status || result.errors) {
      throw new Error(result.description || result.message || 'Unable to add this product to your cart.');
    }

    const modal = cta.closest('modal-dialog');

    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    }

    window.location.href = cta.href;
  } catch (error) {
    console.error(error);
    window.alert(error.message);
    cta.removeAttribute('aria-disabled');
    cta.classList.remove('loading');
  }
});
